export const GET = "GET";
export const SETLIST = "SETLIST";
export const SETDOCUMENTLIST = "SETDOCUMENTLIST";
export const SETCUSTOMERLIST = "SETCUSTOMERLIST";
export const SETITEMLIST = "SETITEMLIST";
export const SETITEMMODALVISIBLE = "SETITEMMODALVISIBLE";
export const SETITEMS = "SETITEMS";
export const SETQUOTECUSTOMERLIST = "SETQUOTECUSTOMERLIST";
export const SETTAXLIST = "SETTAXLIST";
export const SETFLEXIQUOTE = "SETFLEXIQUOTE";
export const CLEARDOC = "CLEARDOC";
export const SETCURRENCYLIST = "SETCURRENCYLIST";
export const SETFLEXIQUOTEBASICFILTERDATA = "SETFLEXIQUOTEBASICFILTERDATA";